import { FAQInfoSectionSerializer } from './FAQInfoSectionSerializer';

class FAQInfoMainSectionSerializer {
  static deSerialize(data) {
    return {
      title: data.title,
      sections: data.sections.map(FAQInfoSectionSerializer.deSerialize),
    };
  }
}

export { FAQInfoMainSectionSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/FAQInfoMainSectionSerializer.js